export default __webpack_public_path__ + "static/media/ino.7c39a73a.jpg";